<template>
    <div class="metric-block">
        <div class="metric-label">
            {{ props.metric }}
        </div>
        <div v-if="Array.isArray(props.value)">
            <div v-for="(value, index) in props.value" :key="index" class="metric-value" :class="{ bold: props.bold }">
                {{ value }}
            </div>
        </div>
        <div v-else class="metric-value" :class="{ bold: props.bold }">
            {{ props.value }}
        </div>
    </div>
</template>

<script lang="ts" setup>

const props = defineProps<{
    metric: string;
    value: string | number | string[] | number[];
    bold?: boolean;
}>();
</script>

<style lang="scss" scoped>
.metric-value {
    font-weight: var(--boldFontWeight);
    color: var(--accentColour);
}
.metric-block {
    align-items: center;
    background-color: var(--neutral200);
    display: grid;
    gap: var(--defaultSpacing);
    text-align: center;
    width: 100%;
    height: 100%;
    padding: var(--smallSpacing);
    border-radius: var(--borderRadiusOuter);
}

</style>
